import {Tag} from "antd";
import React from "react";
import ResultTable from "../../components/table/ResultTable";
import ResultHeader from "../../components/table/ResultHeader";
import ResultBody from "../../components/table/ResultBody";
import ResultRow from "../../components/table/ResultRow";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import {useAppContext} from "../../context/AppContext";


export default function MessageSelectedComparison({dataSource}) {
    const {resolveHistorySelection} = useAppContext()
    const resolveRec = (record) => resolveHistorySelection(record) || {base: {}, compare: {}}

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Folder</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Project</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Plan</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>River</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        dataSource.map(record => {
                            const sel = resolveRec(record)
                            const base = sel.base || {}
                            const compare = sel.compare || {}
                            return (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {base?.project?.information?.folderName}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {compare?.project?.information?.folderName}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <Tag>{base?.project?.modelType}</Tag>
                                                    <span style={{
                                                        marginRight: 4,
                                                    }}>{base?.project?.information?.title?.trim()}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Tag>{compare?.project?.modelType}</Tag>
                                                    <span style={{
                                                        marginRight: 4,
                                                    }}>{compare?.project?.information?.title?.trim()}</span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {base?.plan?.type}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {compare?.plan?.type}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        <table style={{minWidth: 250}}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {(record?.selection?.compare?.river?.river) ? `${record?.selection?.compare?.river?.river} - ${record?.selection?.compare?.river?.reach}` : '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {(record?.selection?.compare?.river?.river) ? `${record?.selection?.compare?.river?.river} - ${record?.selection?.compare?.river?.reach}` : '-'}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}